'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const BalanceIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 19.2V4.79999M4 4.79999H20M2 19.2H22M17.4 6.19999L14.4 12.4C15.3 12.9 16.3 13.2 17.4 13.2C18.5 13.2 19.5 12.9 20.4 12.4L17.4 6.19999ZM6.6 6.19999L3.6 12.4C4.5 12.9 5.5 13.2 6.6 13.2C7.7 13.2 8.7 12.9 9.6 12.4L6.6 6.19999Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpBalanceIcon = forwardRef(BalanceIcon);

export { VpBalanceIcon as default };
